import { Injectable, inject, signal, computed } from '@angular/core';
import { UserSettingsService } from './user-settings.service';

function getSystemPrefersDark(): boolean {
  return typeof window !== 'undefined' && 'matchMedia' in window
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : true;
}

/**
 * Resolves the effective light/dark state from UserSettingsService.themeMode(),
 * tracking the OS preference live for 'system' mode. Single source of truth so
 * the root shell (data-theme attribute) and the map (base style) agree.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly settings = inject(UserSettingsService);

  private readonly systemPrefersDark = signal(getSystemPrefersDark());

  readonly isDark = computed(() => {
    const mode = this.settings.themeMode();
    return mode === 'system' ? this.systemPrefersDark() : mode === 'dark';
  });

  constructor() {
    if (typeof window !== 'undefined' && 'matchMedia' in window) {
      window.matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('change', e => this.systemPrefersDark.set(e.matches));
    }
  }
}
